<template>
  <v-toolbar
    flat
    dark
    height="56"
    max-height="56"
    color="secondary"
    class="h-toolbar-pa-0"
  >
    <v-slide-x-reverse-transition
      v-for="(group, i) in groups"
      :key="`g${group.id}`"
      hide-on-leave
    >
      <v-slide-group
        v-if="i == groupTab"
        v-model="categoryTab"
        show-arrows
        mandatory
        @change="$emit('change')"
      >
        <v-slide-item
          v-for="category in categories(group.id)"
          :key="`c${category.id}`"
          :value="category.id"
          v-slot="{ active, toggle }"
        >
          <v-btn
            icon
            width="44"
            height="44"
            color="white"
            class="ml-2"
            active-class="primary"
            :input-value="active"
            @click="toggle"
          >
            <h-avatar
              :resource="category"
              size="40"
              color="secondary"
              loading-color="primary"
            />
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-slide-x-reverse-transition>
  </v-toolbar>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import HAvatar from '@/Components/Avatar'

  export default {
    components: {
      HAvatar,
    },

    computed: {
      ...mapState('catalog', [
        'groupTab',
        'categoryTabs',
      ]),
      ...mapGetters('catalog', [
        'groups',
        'categories',
      ]),
      categoryTab: {
        get () {
          return this.categoryTabs[this.groupTab]
        },
        set (v) {
          this.$store.commit('catalog/categoryTab', v)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-toolbar-pa-0 > div {
    padding: 0;
  }
</style>
